import { CheckIcon } from "@ui/components/internal/CheckIcon";
import { Checkbox as RACCheckbox, type CheckboxProps as RACCheckboxProps } from "@ui/primitives/CheckboxGroup";
import { composeRenderProps } from "@ui/primitives/shared";
import type { ReactNode } from "react";
import { checkbox } from "./styles";

export interface CheckboxProps extends Omit<RACCheckboxProps, "children"> {
  /** The text shown next to the box. */
  label: ReactNode;
}

export function Checkbox({ label, className, ...props }: CheckboxProps) {
  const slots = checkbox();

  return (
    <RACCheckbox
      {...props}
      className={composeRenderProps(className, (resolved) => slots.root({ className: resolved }))}
    >
      {({ isSelected, isHovered, isFocusVisible }) => (
        <>
          <span aria-hidden="true" className={slots.box({ isSelected, isHovered, isFocusVisible })}>
            {isSelected && <CheckIcon className="size-3" />}
          </span>
          <span className={slots.label()}>{label}</span>
        </>
      )}
    </RACCheckbox>
  );
}
